
































import MessageDisplay from '@/components/MessageDisplay.vue';
import CommandDisplay from '@/components/CommandDisplay.vue';
import IMessage from '@/interfaces/message';
import { IDisplayParams } from '@/interfaces/displayParams';
import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import ICommand from '@/interfaces/command';

@Component({
  components: {
    MessageDisplay,
    CommandDisplay,
  },
})
export default class FilterResult extends Vue {
  @Prop({ required: true })
  public message!: IMessage;

  @Prop({ required: true })
  public displayParams!: IDisplayParams;

  public displayCommands: ICommand[] = [];

  public mounted() {
    this.onDisplayParamsChanged(this.displayParams);
  }

  public printData(jsonObj: JSON) {
    let returnString = '';
    for (const key of Object.keys(jsonObj)) {
      returnString += `${key}: ${(jsonObj as any)[key]}, `;
    }
    // TODO: Determine if there is a better way to do this parsing
    return returnString.substr(0, returnString.length - 2);
  }

  @Watch('displayParams')
  public onDisplayParamsChanged(val: IDisplayParams) {
    this.displayCommands = this.message.commands.filter(c =>
      val.showCommands.includes(c.name)
    );
    if (val.showFileOnly) {
      this.displayCommands = this.displayCommands.filter(c => c.file !== null);
    }
  }
}
